import { runAsPublic } from "../../../helpers/api-helper";
import {AppResourceSearch, ApiFilter} from '@sellers-shield-home-protection/ss-core-js';
import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";
import SellerAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/SellerAppResource";
import {useAuthStore } from '@store';

const actions = {
    increment (){
        this._counter++;
    },
    async fetchLuStateAppResourceSearch() {
        let luStateAppResourceSearch = new AppResourceSearch('lu-state');
        const searchData = {
            pagination: 'disabled',
            filter: new ApiFilter({
                params: {
                    isEnabled: true,
                },
            }),
        };
        await luStateAppResourceSearch.setSearchData(searchData);
        await luStateAppResourceSearch.search();
        this._luStateAppResourceCollection = luStateAppResourceSearch;
    },
};

export default actions;
